import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Icon } from '../Icon';
import './styles.css';

const BackButton = ({ onClick, label = "Retour" }) => {
  const navigate = useNavigate();
  
  const handleClick = () => {
    if (onClick) {
      onClick();
    } else {
      navigate(-1);
    }
  };

  return (
    <button 
      className="ds-back-button"
      onClick={handleClick}
      aria-label={label}
    >
      <Icon name="arrow-left" size={24} />
    </button>
  );
};

export default BackButton; 